const MC_SELECTED_OPERATIONAL_DATE_KEY = 'mc-selected-operational-date';

function validOperationalDate(value = '') {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || Number(value.slice(0, 4)) < 2020) return false;
  const date = new Date(`${value}T12:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}

// Sessions and Dashboard links must agree on the business day. A later edit or
// verification timestamp does not move a count to a different operational day.
export function getSessionOperationalDate(session = {}) {
  const meta = session?.meta || session?.detailSnapshot?.meta || {};
  const explicit = String(session?.operationalDate || session?.businessDate || session?.countDate
    || meta.operationalDate || meta.businessDate || meta.countDate || '').slice(0, 10);
  if (validOperationalDate(explicit)) return explicit;
  const idMatch = String(session?.sessionId || session?.sourceSessionId || '').match(/^MC-(\d{2})(\d{2})(\d{2})(?:-|$)/i);
  if (idMatch) {
    const date = `20${idMatch[1]}-${idMatch[2]}-${idMatch[3]}`;
    if (validOperationalDate(date)) return date;
  }
  const raw = session?.startedAt || session?.createdAt || meta.startedAt || meta.createdAt || session?.updatedAt;
  const time = raw ? new Date(raw).getTime() : NaN;
  if (!Number.isFinite(time)) return '';
  const parts = new Intl.DateTimeFormat('en', { timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(time);
  const date = ['year', 'month', 'day'].map((type) => parts.find((part) => part.type === type).value).join('-');
  return validOperationalDate(date) ? date : '';
}

export function buildSessionReviewHref(session = {}) {
  const params = new URLSearchParams();
  const date = getSessionOperationalDate(session);
  const id = String(session?.sessionId || session?.sourceSessionId || '').trim();
  if (date) params.set('date', date);
  if (id) params.set('session', id);
  const query = params.toString();
  return `/morpheus-count/sessions${query ? `?${query}` : ''}`;
}

export function getSessionReviewTarget(search = '') {
  const params = new URLSearchParams(search);
  const date = String(params.get('date') || '');
  return { date: validOperationalDate(date) ? date : '', sessionId: String(params.get('session') || '').trim() };
}

export function getRememberedOperationalDate() {
  try {
    return String(window.sessionStorage?.getItem(MC_SELECTED_OPERATIONAL_DATE_KEY) || '').slice(0, 10);
  } catch (_) {
    return '';
  }
}

export function rememberOperationalDate(value) {
  const date = String(value || '').slice(0, 10);
  if (!date) return;
  try { window.sessionStorage?.setItem(MC_SELECTED_OPERATIONAL_DATE_KEY, date); } catch (_) {}
}

export function clearRememberedOperationalDate() {
  try { window.sessionStorage?.removeItem(MC_SELECTED_OPERATIONAL_DATE_KEY); } catch (_) {}
}

export function installOperationalDateRefreshReset() {
  const clear = () => clearRememberedOperationalDate();
  window.addEventListener('beforeunload', clear);
  return () => window.removeEventListener('beforeunload', clear);
}
